module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-style-368827d5.svg";